module.exports = __webpack_public_path__ + "img/valance-standard.57f31dc8.svg";